import { Modal } from "react-bootstrap";
import { WebCamModal } from "../UserProfile/WebCam/CameraModal";
import { useContext, useState } from "react";
import { SelectedImageContext } from "../../SelectedImageContext";
import { CameraContext } from "../../CameraContext";
import ImageModal from "../UserProfile/WebCam/ImageModal";

interface ModalProps {
    showModal: boolean;
    handleCloseModal: () => void;
    SendAttachmentInChat: () => void
}


const ModalAttachmentInput: React.FC<ModalProps> = ({ showModal, handleCloseModal, SendAttachmentInChat }) => {

    const { setAttachmentFile } = useContext(SelectedImageContext);
    const { isOpen, setOpenCamera } = useContext(CameraContext);
    const [showImgModal, setShowImgModal] = useState<boolean>(false);

    const SendAttachment = () => {
        setShowImgModal(false);
        SendAttachmentInChat();
    }
    const onFileChanged = (file: File) => {
        handleCloseModal();
        setAttachmentFile(file);
        setShowImgModal(true);
    };
    const openCameraR = () => {
        handleCloseModal();
        setOpenCamera(true);
    }

    return (
        <>
            <Modal
                backdrop={false}
                centered
                show={showModal}
                onHide={handleCloseModal}
            >
                <Modal.Body>
                    Only one person per picture. No text or filters.
                    <div className="mt-3">
                        {/* Add Camera Functionbality Later */}
                        <button className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2" onClick={openCameraR}>
                            Camera
                        </button>
                        <label
                            className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 "
                            style={{ cursor: "pointer" }}
                        >
                            <input
                                type="file"
                                id="fileInput"
                                style={{ display: "none" }}
                                className="col-12 mt-2"
                                onChange={(e) => e.target.files ? onFileChanged(e.target.files[0]) : undefined}
                            />
                            Gallery
                        </label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="link btns btnMO justify-content-center d-flex  align-content-center  col-12  mb-2"
                        onClick={handleCloseModal}
                    >
                        Cancel
                    </button>
                </Modal.Footer>
            </Modal>

            {isOpen && <WebCamModal setShowCropModal={() => { }} uploadImgAfterCapture={true} setShowImgModal={setShowImgModal} />}

            <ImageModal showImgModal={showImgModal} handleCloseModal={setShowImgModal} setOpenCamera={setOpenCamera} UploadImage={SendAttachment} />
        </>
    )
}

export default ModalAttachmentInput